import { FinalPanel } from 'src/pages/Final';
import { IntroPanel } from 'src/pages/Intro';
import { PostCardPanel } from 'src/pages/PostCard';
import { PuzzleGamePannel } from 'src/pages/PuzzleGamePage';
import { ResultsPanel } from 'src/pages/Results';
import { RulesPanel } from 'src/pages/Rules';
import { SecondstageNominatiosPanel } from 'src/pages/SecondStageNominations';
import { SecondStageVoitingPanel } from 'src/pages/SecondStageVoiting';
import { VoitingPanel } from 'src/pages/Voiting';

// TODO: добавить условие, чтобы не отрисовывать все карточки (в зависимости от стадии)

export const AppPanels = {
  INTRO: 'intro_panel',
  RULES: 'rules_panel',
  VOITING: 'voiting_panel',
  FINAL: 'final_panel',
  RESULTS: 'result_panel',
  SECOND_STAGE_VOITING: 'second_stage_voiting_panel',
  SECOND_STAGE_NOMINATIONS: 'second_stage_nominations_panel',
  POST_CARD: 'post_card_panel',
  PUZZLE_GAME: 'puzzle_game_panel'
} as const;

export type AppPanelsT = (typeof AppPanels)[keyof typeof AppPanels];

export const routeConfig = [
  <IntroPanel key={AppPanels.INTRO} id={AppPanels.INTRO} />,
  <RulesPanel key={AppPanels.RULES} id={AppPanels.RULES} />,
  <VoitingPanel key={AppPanels.VOITING} id={AppPanels.VOITING} />,
  <FinalPanel key={AppPanels.FINAL} id={AppPanels.FINAL} />,
  <ResultsPanel key={AppPanels.RESULTS} id={AppPanels.RESULTS} />,
  <SecondstageNominatiosPanel
    key={AppPanels.SECOND_STAGE_NOMINATIONS}
    id={AppPanels.SECOND_STAGE_NOMINATIONS}
  />,
  <SecondStageVoitingPanel
    key={AppPanels.SECOND_STAGE_VOITING}
    id={AppPanels.SECOND_STAGE_VOITING}
  />,
  <PostCardPanel key={AppPanels.POST_CARD} id={AppPanels.POST_CARD} />,
  <PuzzleGamePannel key={AppPanels.PUZZLE_GAME} id={AppPanels.PUZZLE_GAME} />
];
